import styled from 'styled-components';

export const LanguageContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const Dropdown = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #f16024;
  font-family: 'Barlow', sans-serif;
  font-size: 16px;
  font-weight: 300;
  transition: color 0.3s ease-in-out;

  &:hover {
    color: #c3c3c3;
  }

  span {
    display: flex;
    align-items: center;
  }
`;

export const DropdownContent = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #1a1a1a;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-width: 140px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-5px);
  transition:
    opacity 0.2s ease-in-out,
    transform 0.2s ease-in-out;

  &.open {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  button {
    margin-top: 10px;
    padding: 10px 12px;
    width: 100%;
    text-align: left;
    border: none;
    background: none;
    cursor: pointer;
    font-family: 'Barlow', sans-serif;
    font-size: 14px;
    color: #f16024;
    transition: background 0.3s ease-in-out;
    border: 1px solid transparent;

    &:hover {
      border: 1px solid #f16024;
      color: #c3c3c3;
    }
  }
`;

export const ChevronIcon = styled.span`
  transition: transform 0.3s ease-in-out;
  display: flex;
  align-items: center;
  font-size: 12px;

  ${({ isOpen }) => isOpen && `transform: rotate(180deg);`}
`;
